//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";

export default {
  name: "ColorItem",
  components: { IconView },
  inject: ['source'],
  props: {
    data: {
      type: Object,
      required: true
    },
    light: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isLabel() {
      return this.data.value.type === 'label'
    }
  },
  methods: {
    getDate([from, to]) {
      if (!from && !to) {
        return ''
      }
      if (!to) {
        return `${from[0] || ''} ${from[1] || ''}`
      } else {
        return `${from[0] || ''} ${from[1] || ''} - ${to[0] || ''} ${to[1] || ''}`
      }
    },
  }
}
